// JavaScript Document

/* category List */
function categoryli(callback,append){
var categorylist = "";
    $.ajax({
        url: '//www.kontatsu.co.jp/wp/wp-content/themes/kontatsu-child/assets/json/' + callback + '.jsonp',
        type:"GET",
        dataType:"jsonp",
	jsonpCallback: callback,
        error:function() {
//            alert("ロード失敗");
        },
        success: function(json){
	 	var len = json.length;
    		for(var i=0; i < len; i++){
				if(json[i].url != ""){
					categorylist = '<li><a href="' + json[i].url_o + '" target="_top">' + json[i].name + '</a></li>';
				} else {
					categorylist = '';
				}
   				$(append).append(categorylist);
   			}
		}
    })
};

